export const VIZ_API='https://fast-peak-26538.herokuapp.com';
// export const VIZ_API='http://localhost:5000';